import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
    //Romo Time keeper
  {
    x: 1570,
    y: 1530,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'toilet_1',
      nodes: {
        toilet_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Toilet umum, sepertinya baru dipakai.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/toilet-all.png',
          nextDialogId: 'toilet_2',
        },
        toilet_2: {
          id: 'toilet_1',
          speaker: '',
          text: '',
          backgroundImage: '/assets/cutscene/toilet-all.png',
          choices: [
            {
              text: 'Periksa suasana toilet',
              nextDialogId: 'toilet_a1',
            },
            {
              text: 'Periksa isi toilet',
              nextDialogId: 'toilet_b1'
            },
            {
              text: 'Keluar',
              isEnd : true
            }
          ]
        },
        toilet_a1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Toilet sangat lembab',
          backgroundImage: '/assets/cutscene/toilet-all.png',
          nextDialogId: 'toilet_a2'
        },
        toilet_a2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Dan juga baunya tidak sedap',
          backgroundImage: '/assets/cutscene/toilet-all.png',
          nextDialogId: 'toilet_2'
        },
        toilet_b1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Banyak bekas darah di toilet',
          backgroundImage: '/assets/cutscene/toilet-from-above.png',
          nextDialogId: 'toilet_2'
        },
      },
    },
  },
  {
    x: 2200,
    y: 1280,
    name: 'Holga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_holga.png', // Use NPC image
    flipSprite : false,
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Saya baru mendengar tentang adikmu.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Turut berduka cita.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_3",
        },
        holga_3: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Yang terjadi kepada Sondakh dan adikmu, semoga pelakunya ditemukan`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_4",
        },
        holga_4: {
          id: 'holga_1',
          speaker: '',
          text: ``,
          choices: [
            {
              text: 'Terima kasih, kita diposisi yang sama',
              nextDialogId: 'holga_a1',
              storyAction: { type: 'addCustomValue', value: {key : "holga_affinity", value : 1} },
            },
            {
              text: 'Menurut ibu siapa yang melakukan ini',
              nextDialogId: 'holga_b1'
            },
            {

              text: 'Apa yang bu Holga lakukan tadi pagi',
              nextDialogId: 'holga_c1',
              storyAction: { type: 'addCustomValue', value: {key : "holga_affinity", value : -1} },
              requirements : {
                requiredStates : ["HOLGA_FOUND_MORNING"]
              }
            },
          ],
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_4",
        },
        holga_a1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Sebagai tetangga kita harus saling mendukung.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_4",
          isEnd : true
        },
        holga_b1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Hampir pasti, ini perbuatan Songko`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_b2",
        },
        holga_b2: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Target Songko selalu perempuan muda. Kamu harus hati-hati juga.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_b3",
        },
        holga_b3: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Selain temanmu Elsa... Teman mu Bunga juga mencurigakan.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_b4",
        },
        holga_b4: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Saya dengar kemarin saat kematian Sondakh, dia juga sedang di sekitar Danau.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_4",
          isEnd : true
        },
        holga_c1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Saya, saya hanya kebetulan lewat saja`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "holga_c2",
        },
        holga_c2: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Bukan urusan kamu`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1700,
    y: 1550,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan, aku takut, apa yang terjadi?`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Pertama Sondakh, lalu Diana... Siapa yang tega?`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3",
        },
        elsa_3: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Terlebih, kenapa aku yang disalahkan?`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3a",
        },
        elsa_3a: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Sumpah aku di toilet dari tadi pagi, perut ku tidak enak.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3b",
        },
        elsa_3b: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Disaat itulah Diana dibunuh`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_4",
        },
        elsa_4: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Tenang saja Elsa, pasti, kita akan menemukan pelakunya',
              nextDialogId: 'elsa_a1',
              storyAction: { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
              //TODO tambahin dialog chain buat investasi elsa. elsa aku butu bantuan kamu utk memecahkan
            },
            {
              text: 'Aku juga takut Elsa. Kita harus saling menjaga',
              nextDialogId: 'elsa_b1',
            },
          ],
        },
        elsa_a1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Semoga kamu benar Yan.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'elsa_e1',
        },
        elsa_b1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aku setuju.. Terima kasih Yan.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'elsa_e1',
        },
        elsa_e1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Kamu hebat sekali, selalu tenang di situasi seperti ini.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
        },
        elsa_e2 : {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Ayo kita bergegas ke gereja. Hal terbaik adalah untuk mendoakan Diana.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1810,
    y: 1530,
    name: 'Nenek',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_nenek2.png', // Use NPC image
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'nenek_1',
      nodes: {
        nenek_1: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Yan, nenek tidak tahu harus berbicara apa. Nenek sangat sedih.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_2",
        },
        nenek_2: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Situasi di desa sudah tidak aman.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_3",
        },
        nenek_3: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Ini pasti ulah Songko, ini kejadian yang sama seperti 15 tahun lalu.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_4",
        },
        nenek_4: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Sebaiknya kamu pergi sekarang. Gadis sepertimu selalu jadi sasaran Songko. Tidak aman disini`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_5",
        },
        nenek_5: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          choices: [
            {
              text: 'Aku tidak mau meninggalkan Diana',
              nextDialogId: 'nenek_6',
            },
            {
              text: 'Aku harus mencari tahu pelaku dibalik semua ini.',
              nextDialogId: 'nenek_6',
            },
          ],
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        nenek_6: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Baiklah, nenek paham`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_7",
        },
        nenek_7: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Nenek juga ingin mencari tahu kebenaran dibalik ini.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_8",
        },
        nenek_8: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Nenek sarankan, satu hari`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_9",
        },
        nenek_9: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Hari ini coba cari tahu sebaik-baiknya tentang kematian Diana, setelah itu, sebaiknya besok kamu pulang.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_10",
        },
        nenek_10: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Dan bawa temanmu juga kembali ke kota.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_11",
        },
        nenek_11: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Sejujurnya nenek juga tidak terlalu percaya dengan temanmu, jadi lebih baik dia juga ikut pergi`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_11a",
        },
        nenek_11a: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Tetapi menurut nenek, semua wanita di desa ini, bisa jadi Songko`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_11b",
        },
        nenek_11b: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Holga, temanmu Bunga, Elsa, kita harus berhati-hati.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_12",
        },
        nenek_12: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          choices: [
            {
              text: 'Aku akan cari tahu sebisa mungkin',
              nextDialogId: 'nenek_13',
            },
            {
              text: 'Baik nek. Aku akan berhati-hati',
              nextDialogId: 'nenek_13',
            },
          ],
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
        },
        nenek_13: {
          id: 'elsa_1',
          speaker: 'Nenek',
          text: `Sampai ketemu di Gereja`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2400,
    y: 1250,
    name: 'Bunga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Selamat pagi Yan, apa kabar hari ini?`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_2",
        },
        bunga_2: {
          id: 'bunga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Kamu dari mana saja Bunga? Pagi-pagi sudah pergi?',
              nextDialogId: 'bunga_a1',
            },
            {
              text: 'Diana, meninggal',
              nextDialogId: 'bunga_b1',
            },
          ],
        },
        bunga_b1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Diana? Apa yang terjadi?`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_b2",
        },
        bunga_b2: {
          id: 'bunga_b2',
          speaker: 'Bunga',
          text: `Dimana Diana sekarang!`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_b3",
        },
        bunga_b3: {
          id: 'bunga_b2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Mayat Diana sedang dibawa ke Gereja',
              nextDialogId: 'bunga_b4',
            },
            //TODO tergantung siapa yang nemuin
            {
              text: 'Aku menemukan Diana meninggal di kamarnya tadi pagi',
              nextDialogId: 'bunga_b4',
            },
            {
              text: 'Elsa menemukan Diana meninggal di kamarnya tadi pagi',
              nextDialogId: 'bunga_b4',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
            },
          ],
        },
        bunga_b4: {
          id: 'bunga_b2',
          speaker: 'Bunga',
          text: `...`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'bunga_b5',
        },
        bunga_b5: {
          id: 'bunga_b2',
          speaker: 'Bunga',
          text: `Aku butuh waktu untuk memproses ini.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
        bunga_a1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Aku dari Danau, baru membasuh diri.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_a2",
        },
        bunga_a2: {
          id: 'bunga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Kenapa pagi-pagi sudah di danau?',
              nextDialogId: 'bunga_aa1',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : -1} },
            },
            {
              text: 'Diana, meninggal',
              nextDialogId: 'bunga_ab1',
            },
          ],
        },
        bunga_aa1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Aku memang sering melakukan itu, air dingin mempercantik kulit`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_aa2",
        },
        bunga_aa2: {
          id: 'bunga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Apakah kamu tahu yang terjadi tadi? Diana meninggal.',
              nextDialogId: 'bunga_b1',
            },
            {
              text: 'Jangan bohong, kenapa harus pagi-pagi mandi di danau? Apa yang sedang kamu sembunyikan?',
              nextDialogId: 'bunga_ab1',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : -1} },
            },
          ],
        },
        bunga_ab1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Apa yang terjadi Bunga? Kenapa kamu menanyakan ini ke aku?`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_ab2",
        },
        bunga_ab2: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Aku tidak melakukan apa, aku tidak menyembunyikan apa-apa`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bunga_ab3",
        },
        bunga_ab3: {
          id: 'bunga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Maaf, aku termakan emosi.',
              nextDialogId: 'bunga_b3',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
            },
            {
              text: 'Aku hanya ingin mengethaui kebenaran',
              nextDialogId: 'bunga_b3',
            },
          ],
        },
      },
    },
  },
  {
    x: 1950,
    y: 1530,
    name: 'Ato',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/ato_up.png',
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'ato_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Terima kasih atas bantuannya ya pak',
              nextDialogId: 'ato_2',
              storyAction: { type: 'addCustomValue', value: {key : "ato_affinity", value : 1} },
            },
            {
              text: 'Hati-hati membawa Diana ya',
              nextDialogId: 'ato_2',
            },
          ],
        },
        ato_2: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Yang terjadi kepada adikmu, saya ikut berduka cita.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "ato_3",
        },
        ato_3: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Aku tidak akan memaafkan siapapun dalang dibalik kejadian ini.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "ato_4",
        },
        ato_4: {
          id: 'ato_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Terima kasih pak. Saya menghargai bantuan bapak.',
              nextDialogId: 'ato_a1',
              storyAction: { type: 'addCustomValue', value: {key : "ato_affection", value : 1} },
            },
            {
              text: 'Menurut bapak. Kira-kira siapa yang dibalik semua ini?',
              nextDialogId: 'ato_b1'
              //TODO ini muncul kalau affinity ato-elsa rendah,
            },
            {
              text: 'Menurut bapak. Kira-kira siapa yang dibalik semua ini?',
              nextDialogId: 'ato_c1',
              //TODO ini muncul kalau affinity ato-elsa tinggi, dia gak nuduh elsa,
            },
          ],
        },
        ato_a1: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Tenang saja, kita akan bantu membawa adikmu ke gereja. Sampai jumpa ya.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
        ato_b1: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Sejujurnya, temanmu itu pembawa malapetaka.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'ato_b2',
        },
        ato_b2: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Sejak dia datang ke desa, hanya kemalangan yang terjadi.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
        ato_c1: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Saya tidak tahu, saya pun baru bangun tadi pagi.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'ato_c2',
        },
        ato_c2: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Tetapi semalam saya dijalan sampai larut malam.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'ato_c3',
        },
        ato_c3: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Saya melihat Holga, keluar dari rumahnya.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2340,
    y: 720,
    name: 'Romo Darius',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_darius.png',
    repeatable : true,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'romo_1',
      nodes: {
        romo_1: {
          id: 'romo_1',
          speaker: 'Romo Darius',
          text: `Sekali lagi, turut berduka cita.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'romo_2'
        },
        romo_2: {
          id: 'romo_2',
          speaker: 'Romo Darius',
          text: `Apakah kita sudah siap untuk misa?.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'romo_3'
        },
        romo_3: {
          id: 'romo_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Aku sudah siap',
              storyAction: { type: 'nextDay', value: 0 },
            },
            {
              text: 'Aku ingin menyiapkan diri dulu',
              nextDialogId: 'bunga_ab1',
              isEnd : true
            },
            {
              text: 'Apa opini romo tentang kematian Diana dan Sondakh?',
              nextDialogId: 'romo_4',
            },
          ],
        },
        romo_4: {
          id: 'romo_2',
          speaker: 'Romo Darius',
          text: `Situasi ini sangat sulit, Diana dan Sondakh adalah bagian dari keluarga besar kita.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'romo_5'
        },
        romo_5: {
          id: 'romo_2',
          speaker: 'Romo Darius',
          text: `Apapun yang terjadi, keluarga sangat penting. Saya juga sangat berduka`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'romo_6'
        },
        romo_6: {
          id: 'romo_2',
          speaker: 'Romo Darius',
          text: `Semoga situasi menjadi lebih baik`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd :true
        },
      },
    },
  },
];

export default config;
